import { CAMPAIGN_TEMPLATE } from "./campaign-brief-template.enum";
import { BriefTemplateLabel } from "../brief-template-label.interface";

export const CampaignBriefTemplateLabels: BriefTemplateLabel[] = [
  { label: "General", value: CAMPAIGN_TEMPLATE.GENERAL },
  { label: "Brand", value: CAMPAIGN_TEMPLATE.BRAND },
  { label: "New Product Launch", value: CAMPAIGN_TEMPLATE.NEW_PRODUCT },
  { label: "Simple Single Asset Campaign", value: CAMPAIGN_TEMPLATE.SIMPLE },
];
